import { Button, CardActions, CardContent, Tooltip } from '@mui/material'
import './styles/OrderItem.scss'

import React from 'react'
import { Order } from '../../types/models/Order'
import { parseDateString } from '../../helpers/parseDateString'
import { userFioToString } from '../../helpers/userFioToString'

import { IoCartOutline, IoStarHalfOutline, IoWarningOutline } from 'react-icons/io5'

type Props = {
  order: Order
  noAction?: boolean
  lite?: boolean
  onAccepted?: () => any
  onCompleted?: () => any
  onEnd?: () => any
}

const OrderItem = (props: Props) => {
  const { onAccepted, onCompleted, onEnd, order, noAction, lite } = props

  const isAccepted = !!order.takeTime
  const isCompleted = !!order.compliteTime

  const path = order.locationPath ?? 'неизвестно'

  if (lite) {
    return (
      <div
        className={`OrderItem lite ${order.urgent ? 'urgent' : ''} ${isAccepted ? 'accepted' : 'open'} ${
          isCompleted ? 'complite' : ''
        }`}
        onClick={isCompleted ? onEnd : isAccepted ? onCompleted : onAccepted}
      >
        <Tooltip title={order.material?.name}>
          <h5 className="OrderItem-card-material lite">{order.material?.name}</h5>
        </Tooltip>
        {!noAction ? (
          <div className="OrderItem-card-action lite">
            {isCompleted ? (
              <>
                <IoStarHalfOutline
                  className="OrderItem-card-worker-icon"
                  size={32}
                />
                <p className="OrderItem-card-author lite">
                  Заказ №{order.id}<br />
                  <span>Автор: </span>
                  {order.author ? userFioToString(order.author) : ''}
                </p>
                <Button>Оценить</Button>
              </>
            ) : isAccepted ? (
              <>
                <IoCartOutline
                  className="OrderItem-card-worker-icon"
                  size={32}
                />
                <p className="OrderItem-card-worker lite">
                  Заказ №{order.id}<br />
                  <span>Работает: </span>
                  {order.worker ? userFioToString(order.worker) : null}
                </p>
                <Button>Завершить</Button>
              </>
            ) : (
              <>
                <IoWarningOutline
                  className="OrderItem-card-worker-icon"
                  size={32}
                />
                <p className="OrderItem-card-role lite">
                  Заказ №{order.id}<br />
                  Требуется: {order.role?.value ?? 'Любой'}
                </p>
                <Button>Взять</Button>
              </>
            )}
          </div>
        ) : null}
      </div>
    )
  } // if (lite)

  return (
    <div
      className={`OrderItem ${order.urgent ? 'urgent' : ''} ${isAccepted ? 'accepted' : 'open'} ${
        isCompleted ? 'complite' : ''
      }`}
    >
      <CardContent className="OrderItem-card">
        <Tooltip title={path}>
          <p className="OrderItem-card-location">{path}</p>
        </Tooltip>

        <br />

        <div className="OrderItem-card-time">
          №{order.id}<br />
          {parseDateString(order.updatedAt)}
        </div>

        <h5 className="OrderItem-card-material">{order.material?.name}</h5>
        
        {order.unit ? (
          <h5 className="OrderItem-card-material">{order.quantity} {order.unit.name}</h5>
        ) : (
          <h5 className="OrderItem-card-material none">ЕИ не указана</h5>
        )}
        <p className="OrderItem-card-author">
          {order.author ? userFioToString(order.author) : ''}
        </p>
      </CardContent>
      {!noAction ? (
        <CardActions>
          {order.compliteTime ? (
            <Button onClick={onEnd}>Оценить</Button>
          ) : isAccepted ? (
            <>
              <Button onClick={onCompleted}>Завершить</Button>
              <p className="OrderItem-card-worker">
                <span>Работает: </span>
                {order.worker ? userFioToString(order.worker) : null}
              </p>
            </>
          ) : (
            <Button onClick={onAccepted}>Взять</Button>
          )}
        </CardActions>
      ) : null}
    </div>
  )
}

export default OrderItem
